<template>
    <div>
        <form @submit.prevent="onSubmit"
              @keydown="form.errors.clear($event.target.name)">
            <div class="modal-form-block">
                <label for="id_articolo"
                >
                    {{ trans.get('items.modal.codice_articolo') }}
                </label>
                <input type="text"
                       name="id_articolo"
                       id="id_articolo"
                       :placeholder="this.trans.get('items.modal.codice_articolo_placeholder')"
                       v-model="form.id_articolo"
                >
                <span class="alert alert-danger"
                      v-if="form.errors.has('id_articolo')"
                      v-text="form.errors.get('id_articolo')"
                >
                </span>
            </div>

            <div class="modal-form-block">
                <label for="descrizione">
                    {{ trans.get('items.modal.descrizione') }}
                </label>
                <div class="relative flex items-center">
                    <input type="text"
                           class="w-full"
                           name="descrizione"
                           id="descrizione_it"
                           :placeholder="this.trans.get('items.modal.descrizione_placeholder')"
                           v-model="form.translations.descrizione.it"
                           @blur="copyDescription"
                    >
                    <div class="absolute right-0 py-1 px-3 bg-blue-800 text-white font-bold rounded uppercase mr-4 opacity-50">
                        it
                    </div>
                </div>
                <div class="relative flex items-center mt-2">
                    <input type="text"
                           class="w-full"
                           name="descrizione"
                           id="descrizione_en"
                           :placeholder="this.trans.get('items.modal.descrizione_placeholder')"
                           v-model="form.translations.descrizione.en"
                    >
                    <div class="absolute right-0 py-1 px-2 bg-blue-800 text-white font-bold rounded uppercase mr-4 opacity-50">
                        en
                    </div>
                </div>
                <span class="alert alert-danger"
                      v-if="form.errors.has('descrizione')"
                      v-text="form.errors.get('descrizione')"
                >
                        </span>
            </div>

            <div class="modal-form-block">
                <label for="descrizione_ridotta">
                    {{ trans.get('items.modal.descrizione_ridotta') }}
                </label>
                <input type="text"
                       name="descrizione_ridotta"
                       id="descrizione_ridotta"
                       class="form-control"
                       :placeholder="this.trans.get('items.modal.descrizione_ridotta_placeholder')"
                       v-model="form.descrizione_ridotta"
                >
                <span class="alert alert-danger"
                      v-if="form.errors.has('descrizione_ridotta')"
                      v-text="form.errors.get('descrizione_ridotta')"
                >
                        </span>
            </div>

            <div class="modal-form-block mb-6">
                <label for="item_type">
                    {{ trans.get('items.modal.tipo_parte') }}
                </label>
                <div class="relative w-full">
                    <select name="item_type"
                            id="item_type"
                            v-model="form.item_type_id"
                    >
                        <option :value="item_type.id"
                                v-for="item_type in form.itemTypes"
                                v-text="item_type.descrizione"
                        >
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="modal-form-block mb-6">
                <button class="w-1/3 mx-auto btn is-aitems-700"
                        :disabled="form.errors.any()"
                >
                    {{ trans.get('items.modal.crea') }}
                </button>
            </div>
        </form>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    id_articolo: '',
                    descrizione: '',
                    descrizione_estesa: '',
                    descrizione_ridotta: '',
                    translations: {
                        descrizione: {
                            it: '',
                            en: ''
                        }
                    },
                    itemTypes: [],
                    item_type_id: '',
                }),
            }
        },

        created() {
            this.fillTheCombos();
        },

        methods: {
            onSubmit() {
                this.form.post('/items').then(item => {
                    swal.fire('Grande!!', 'Articolo Creato :)', 'success');
                    this.fillTheCombos();
                    this.$emit('item-has-been-created', item);
                    this.$modal.hide('add-items');
                });

            },

            copyDescription() {
                this.form.descrizione = this.form.translations.descrizione.it;
                this.form.descrizione_estesa = this.form.translations.descrizione.it;

                //DAI GUIDO PUOI FARE MEGLIO DI COSI!
                if (this.form.errors.has('descrizione')) {
                    this.form.errors.clear('descrizione');
                }

                if (this.form.errors.has('descrizione_estesa')) {
                    this.form.errors.clear('descrizione_estesa');
                }
            },

            //Tutta questa funzione adesso è un po' meno brutta :)
            fillTheCombos() {
                this.form.fill('/item_types', 'itemTypes', 'item_type_id', 'id');
            }
        }
    }
</script>